const shallowEqual = (a, b) => {
	for (const key in a) {
		if (a[key] !== b[key]) {
			return false;
		}
	}
	for (const key in b) {
		if (!(key in a)) {
			return false;
		}
	}
	return true;
};

export default shallowEqual;
